{{ cellValue | date: 'short' }}
